<div role="main" class="main">

  <section class="page-header">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <ul class="breadcrumb">
            <li><a href="#">Anasayfa</a></li>
            <li class="active">Bireysel Danışmanlık / Eğitim</li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h1>Bireysel Danışmanlık / Eğitim</h1>
        </div>
      </div>
    </div>
  </section>

  <div class="container">

         <h2><strong>Intes Technology</strong> ile danışmanlık / eğitim süreci</h2>

         <div class="row">
            <div class="col-md-12">
               <p class="lead">
                  Danışmanlık/Eğitimlerde teorik bilgiye önem vermekle birlikte, daha ziyade <strong>uygulamaları referans alarak</strong> çalışmalarımızı sürdürüyoruz. Çünkü <strong>çok iyi biliyoruz</strong> ki yazılım alanında anlatımlar uygulamaya koyulmadığı sürece, hem öğrenilme güçlüğü çekilip kısa sürede unutuluyor, hem de proje içinde uygulamada başarısızlıklara neden oluyor. Tüm danışmanlık/eğitimlerimizde <strong>birlikte projeler geliştiriyor</strong> ve deneyimlerimizi çalışma anında proje üzerinde sizlere aktarıyoruz. Böylelikle <strong>ilgili konuyu iş başında deneyimleyerek</strong> öğrenip deneyimlemenizi sağlıyoruz.
               </p>
            </div>
         </div>

    <hr>

    <div class="row">
      <div class="col-md-12">
        <div class="toggle toggle-primary mt-lg" data-plugin-toggle>
                  <section class="toggle" style="font-size: 14pt !important;">
                     <label>Code Review</label>
                     <div class="toggle-content" style="font-size: 13pt !important;">
                        <p class="lead">
                           Bu hizmeti <strong>Android</strong> ve <strong>Ios</strong> native projeleriniz için veriyoruz.
                        </p>
                        <p class="lead">
                           Java ya da Kotlin ile geliştirilmiş olan android projenizi ya da swift ile geliştirilmiş olan ios projenizi inceliyoruz. Projenizin mimarisini, kodlarınızın temizliğini, ilgili işletim sistemi ile etkileşimi ve uygunluğunu değerlendirip yapılması gerekenleri <strong>detaylıca raporluyoruz</strong>. Ortaya koyacağımız rapor üzerinden elinizdeki kodların, güncellik, performans, kod standartları, platform uygunluğu gibi kriterlerde durumunu görebilir ve gerekli önlemleri alabilirsiniz.
                        </p>

                        <p class="lead">
                           <strong>Uzaktan ya da yerinde hizmet verilmektedir.</strong> Ücretlendirme <strong>saatlik</strong> olarak yapılır.
                           <br>

                           Öngördüğünüz süreye göre satınalma yapabilirsiniz. Sürenin daha fazla sürmesi halinde iş sonucunda ek satınalma gerekmektedir.
                        </p>


                        <input class="btn btn-primary mb-xl" type="button" (click)="changeService(19)" data-toggle="modal" data-target="#exampleModal"   [value]="checkServicePrice(19)">

                     </div>
                  </section>
                  <section class="toggle" style="font-size: 14pt !important;">
                     <label>Proje Başı Danışmanlık</label>
                     <div class="toggle-content" style="font-size: 13pt !important;">

                        <p class="lead">
                           Geliştirdiğiniz projede sizlere yol göstericilik yapıyoruz.
                        </p>

                        <p class="lead">
                           Dilerseniz projenizin başlangıcında mimarilerini oluşturup teslim ediyor, dilerseniz de sizin belirleyeceğiniz süre boyunca projenize, sürekli ya da belli aralıklar ile danışmanlıklar yapıyoruz. Böylelikle çok daha esnek, geliştirilebilir ve kaliteli ürünler ortaya koymanıza yardımcı oluyoruz.
                        </p>

                        <p class="lead">
                           <strong>Uzaktan ya da yerinde hizmet verilmektedir.</strong> Ücretlendirme <strong>saatlik</strong> olarak yapılır.
                           <br>

                           Öngördüğünüz süreye göre satınalma yapabilirsiniz. Sürenin daha fazla sürmesi halinde iş sonucunda ek satınalma gerekmektedir.
                        </p>


                        <input class="btn btn-primary mb-xl" type="button" (click)="changeService(20)" data-toggle="modal" data-target="#exampleModal"   [value]="checkServicePrice(20)">

                     </div>
                  </section>
          <section class="toggle" style="font-size: 14pt !important;">
            <label>Kotlin ile Android - 30 Saat</label>
                     <div class="toggle-content" style="font-size: 13pt !important;">

                        <p class="lead">
                           Kotlin dili kullanılarak android uygulama geliştirme süreçlerini en baştan ele alıp yapılan uygulamalar ile deneyimlerimizi sizlere aktarıyoruz. <strong>Uygulamalı çalışmamız</strong> sayesinde süreç sonunda kendi <strong>uygulamanızı rahatlıkla geliştirebilir</strong> seviyeye gelmenizi sağlıyoruz.
                        </p>


                        <div class="featured-box featured-box-primary">
                        <div class="box-content align-left" style="font-size: 14pt !important;">
                           <h4 >Ön Koşullar</h4>
                           <hr>
                           <div class="toggle-content" style="font-size: 13pt !important;">
                              <ul>
                                 <li>Kotlin dilini bilmek. Eğer bilginiz yoksa temel kotlin eğitimini alabilirsiniz.</li>
                                 <li>Standart programlama yapılarına hakim olmak</li>
                                 <li>Nesne tabanlı programlamayı bilmek</li>
                                 <li>Xml hakkında bilgi sahibi olmak</li>
                              </ul>
                           </div>

                        </div>
                        </div>
                        <div class="featured-box featured-box-primary">
                        <div class="box-content align-left" style="font-size: 14pt !important;">
                           <h4 >İçerik</h4>
                           <hr>

                           <ul class="list list-icons align-left" style="font-size: 13pt !important;">
                              <li><i class="toggle-content"></i> <strong>Android‘e Giriş :</strong> Android yapısı ve mimarisi hakkında bilgiler verilecektir
                              <li><i class="toggle-content"></i> <strong>Geliştirme Ortamı :</strong> Android studio özellikleri ve alışkanlıkları tanıtılacak
                              <li><i class="toggle-content"></i> <strong>SDK ve AVD Manager :</strong> SDK kurulumları ve emulatorlerin kullanımı
                              <li><i class="toggle-content"></i> <strong>Tasarım : </strong>
                                 <div class="toggle-content" style="font-size: 13pt !important;">
                                    <ul>
                                       <li>Design ve xml pencerelerinin kullanımı</li>
                                       <li>Layout, widget kullanımları</li>
                                       <li>Esnek tasarımlar yapmak</li>
                                    </ul>
                                 </div>
                              <li><i class="toggle-content"></i> <strong>Activityler :</strong> Activity kavramı, yaşam döngüsü ve özellikleri işlenecek
                              <li><i class="toggle-content"></i> <strong>Kullanıcı Bilgilendirmeleri :</strong> Alert, toast ve snackbar kullanımları
                              <li><i class="toggle-content"></i> <strong>Olay Yönetimi :</strong> Cihaz Tuşlarının ve ekrana eklenen diğer elemanların olaylarının yönetilmesi
                              <li><i class="toggle-content"></i> <strong>Liste Yapıları :</strong>
                                 <ul>
                                    <li>Listview kullanımı</li>
                                    <li>Özel adapter ile listview kullanımı</li>
                                    <li>Recyclerview kullanımı</li>
                                 </ul>
                              <li><i class="toggle-content"></i> <strong>Birden fazla ekran ile çalışmak :</strong>
                                 <ul>
                                    <li>Farklı ekranlar oluşturmak</li>
                                    <li>Ekranlar arası geçişler</li>
                                    <li>Ekranlar arası veri trasferi</li>
                                    <li>İleri ve geri yönlü geçiş ve veri transferleri</li>
                                 </ul>
                              <li><i class="toggle-content"></i> <strong>Splash Screen :</strong> Açılış ekranı kullanımı ve açılışta işlem yapmak
                              <li><i class="toggle-content"></i> <strong>Menüler :</strong> Sol menü yapısının kullanımı
                              <li><i class="toggle-content"></i> <strong>Local Veri Saklama Yöntemleri :</strong>
                                 <ul>
                                    <li>Shared preferences</li>
                                    <li>Sqlite</li>
                                 </ul>
                              <li><i class="toggle-content"></i> <strong>Uygulama İzinleri :</strong> İşletim sistemi versiyonlarına göre izinlerin alınması
                              <li><i class="toggle-content"></i> <strong>Kamera Kullanımı :</strong> Kameradan fotoğraf çekerek kullanmak
                              <li><i class="toggle-content"></i> <strong>Veri Erişimi :</strong> Dosya sistemine erişmek
                              <li><i class="toggle-content"></i> <strong>Galeri kullanımı :</strong> Galeriden fotoğraf seçimi ve kullanımı
                              <li><i class="toggle-content"></i> <strong>Ek kütüphaneler kullanımı :</strong> Gradle ile kütüphaneler eklemek ve kullanmak
                              <li><i class="toggle-content"></i> <strong>Web Servisleri ile Çalışmak :</strong> Json web servisleri ile JsonObject ve JsonArray kullanımları
                              <li><i class="toggle-content"></i> <strong>Konum Kullanımı :</strong> Konum servislerine erişmek ve konum değerlerini işlemek
                              <li><i class="toggle-content"></i> <strong>Uygulamalar arası veri aktarımı :</strong> Paylaşım yapılarını kullanıp, uygulamamızın paylaşılabilir uygulamalar listesine çıkarmak
                              <li><i class="toggle-content"></i> <strong>Hizmetler ve Alıcılar :</strong> Servis yapıları ve yayınları kullanmak
                              <li><i class="toggle-content"></i> <strong>Bildirim göstermek :</strong> Local bildirimlerin gösterilmesi
                              <li><i class="toggle-content"></i> <strong>Google Haritalar :</strong> Google haritalara giriş yaparak ve konum kullanımıyapmak
                              <li><i class="toggle-content"></i> <strong>GooglePlay Developer Hesabı :</strong> Örnek developer hesabının incelenmesi
                              <li><i class="toggle-content"></i> <strong>Signed Apk Oluşturmak :</strong> Uygulamanın imzalanması
                           </ul>
                        </div>
                     </div>

                     <input class="btn btn-primary mb-xl" type="button" (click)="changeService(21)" data-toggle="modal" data-target="#exampleModal"   [value]="checkServicePrice(21)">

                     </div>
          </section>
                  <section class="toggle" style="font-size: 14pt !important;">
                     <label>Java ile Android - 30 Saat</label>
                     <div class="toggle-content" style="font-size: 13pt !important;">

                        <p class="lead">
                          Java dili kullanılarak android uygulama geliştirme süreçlerini en baştan ele alıp yapılan uygulamalar ile deneyimlerimizi sizlere aktarıyoruz. <strong>Uygulamalı çalışmamız</strong> sayesinde süreç sonunda kendi <strong>uygulamanızı rahatlıkla geliştirebilir</strong> seviyeye gelmenizi sağlıyoruz.
                        </p>

                        <div class="featured-box featured-box-primary">
                        <div class="box-content align-left" style="font-size: 14pt !important;">
                           <h4 >Ön Koşullar</h4>
                           <hr>
                           <div class="toggle-content" style="font-size: 13pt !important;">
                              <ul>
                                 <li>Java, C# gibi syntaxları birbirine yakın dillerden birini bilmek.</li>
                                 <li>Standart programlama yapılarına hakim olmak</li>
                                 <li>Nesne tabanlı programlamayı bilmek</li>
                                 <li>Xml hakkında bilgi sahibi olmak</li>
                              </ul>
                           </div>

                        </div>
                        </div>
                        <div class="featured-box featured-box-primary">
                        <div class="box-content align-left" style="font-size: 14pt !important;">
                           <h4 >İçerik</h4>
                           <hr>

                           <ul class="list list-icons align-left" style="font-size: 13pt !important;">
                              <li><i class="toggle-content"></i> <strong>Android‘e Giriş :</strong> Android yapısı ve mimarisi hakkında bilgiler verilecektir
                              <li><i class="toggle-content"></i> <strong>Geliştirme Ortamı :</strong> Android studio özellikleri ve alışkanlıkları tanıtılacak
                              <li><i class="toggle-content"></i> <strong>SDK ve AVD Manager :</strong> SDK kurulumları ve emulatorlerin kullanımı
                              <li><i class="toggle-content"></i> <strong>Tasarım : </strong>
                                 <div class="toggle-content" style="font-size: 13pt !important;">
                                    <ul>
                                       <li>Design ve xml pencerelerinin kullanımı</li>
                                       <li>Layout, widget kullanımları</li>
                                       <li>Esnek tasarımlar yapmak</li>
                                    </ul>
                                 </div>
                              <li><i class="toggle-content"></i> <strong>Activityler :</strong> Activity kavramı, yaşam döngüsü ve özellikleri işlenecek
                              <li><i class="toggle-content"></i> <strong>Kullanıcı Bilgilendirmeleri :</strong> Alert, toast ve snackbar kullanımları
                              <li><i class="toggle-content"></i> <strong>Olay Yönetimi :</strong> Cihaz Tuşlarının ve ekrana eklenen diğer elemanların olaylarının yönetilmesi
                              <li><i class="toggle-content"></i> <strong>Liste Yapıları :</strong>
                                 <ul>
                                    <li>Listview kullanımı</li>
                                    <li>Özel adapter ile listview kullanımı</li>
                                    <li>Recyclerview kullanımı</li>
                                 </ul>
                              <li><i class="toggle-content"></i> <strong>Birden fazla ekran ile çalışmak :</strong>
                                 <ul>
                                    <li>Farklı ekranlar oluşturmak</li>
                                    <li>Ekranlar arası geçişler</li>
                                    <li>Ekranlar arası veri trasferi</li>
                                    <li>İleri ve geri yönlü geçiş ve veri transferleri</li>
                                 </ul>
                              <li><i class="toggle-content"></i> <strong>Splash Screen :</strong> Açılış ekranı kullanımı ve açılışta işlem yapmak
                              <li><i class="toggle-content"></i> <strong>Menüler :</strong> Sol menü yapısının kullanımı
                              <li><i class="toggle-content"></i> <strong>Local Veri Saklama Yöntemleri :</strong>
                                 <ul>
                                    <li>Shared preferences</li>
                                    <li>Sqlite</li>
                                 </ul>
                              <li><i class="toggle-content"></i> <strong>Uygulama İzinleri :</strong> İşletim sistemi versiyonlarına göre izinlerin alınması
                              <li><i class="toggle-content"></i> <strong>Kamera Kullanımı :</strong> Kameradan fotoğraf çekerek kullanmak
                              <li><i class="toggle-content"></i> <strong>Veri Erişimi :</strong> Dosya sistemine erişmek
                              <li><i class="toggle-content"></i> <strong>Galeri kullanımı :</strong> Galeriden fotoğraf seçimi ve kullanımı
                              <li><i class="toggle-content"></i> <strong>Ek kütüphaneler kullanımı :</strong> Gradle ile kütüphaneler eklemek ve kullanmak
                              <li><i class="toggle-content"></i> <strong>Web Servisleri ile Çalışmak :</strong> Json web servisleri ile JsonObject ve JsonArray kullanımları
                              <li><i class="toggle-content"></i> <strong>Konum Kullanımı :</strong> Konum servislerine erişmek ve konum değerlerini işlemek
                              <li><i class="toggle-content"></i> <strong>Uygulamalar arası veri aktarımı :</strong> Paylaşım yapılarını kullanıp, uygulamamızın paylaşılabilir uygulamalar listesine çıkarmak
                              <li><i class="toggle-content"></i> <strong>Hizmetler ve Alıcılar :</strong> Servis yapıları ve yayınları kullanmak
                              <li><i class="toggle-content"></i> <strong>Bildirim göstermek :</strong> Local bildirimlerin gösterilmesi
                              <li><i class="toggle-content"></i> <strong>Google Haritalar :</strong> Google haritalara giriş yaparak ve konum kullanımıyapmak
                              <li><i class="toggle-content"></i> <strong>GooglePlay Developer Hesabı :</strong> Örnek developer hesabının incelenmesi
                              <li><i class="toggle-content"></i> <strong>Signed Apk Oluşturmak :</strong> Uygulamanın imzalanması
                           </ul>
                        </div>
                     </div>

                     <input class="btn btn-primary mb-xl" type="button" (click)="changeService(23)" data-toggle="modal" data-target="#exampleModal"   [value]="checkServicePrice(23)">

                     </div>
                  </section>

                  <section class="toggle" style="font-size: 14pt !important;">
                     <label>Swift ile Ios - 30 Saat</label>
                     <div class="toggle-content" style="font-size: 13pt !important;">

                        <p class="lead">
                          Swift dili kullanılarak ios uygulama geliştirme süreçlerini en baştan ele alıp yapılan uygulamalar ile deneyimlerimizi sizlere aktarıyoruz. <strong>Uygulamalı çalışmamız</strong> sayesinde süreç sonunda kendi <strong>uygulamanızı rahatlıkla geliştirebilir</strong> seviyeye gelmenizi sağlıyoruz.
                        </p>

                        <div class="featured-box featured-box-primary">
                        <div class="box-content align-left" style="font-size: 14pt !important;">
                           <h4 >Ön Koşullar</h4>
                           <hr>
                           <div class="toggle-content" style="font-size: 13pt !important;">
                              <ul>
                                 <li>Herhangi bir dilde yazılım bilmek.</li>
                                 <li>Standart programlama yapılarına hakim olmak</li>
                                 <li>Nesne tabanlı programlamayı bilmek</li>
                              </ul>
                           </div>

                        </div>
                        </div>
                        <div class="featured-box featured-box-primary">
                        <div class="box-content align-left" style="font-size: 14pt !important;">
                           <h4 >İçerik</h4>
                           <hr>

                           <ul class="list list-icons align-left" style="font-size: 13pt !important;">
                              <li><i class="toggle-content"></i> <strong>Developer Hesabı :</strong> Örnek bir developer hesabı üzerinden developer hesabı ve appstore incelemesi
                              <li><i class="toggle-content"></i> <strong>Geliştirme Ortamı :</strong> Xcode özellikleri ve alışkanlıkları tanıtılacak
                              <li><i class="toggle-content"></i> <strong>Swift Dili :</strong> En baştan mobil uygulama geliştirmek için gerekli olan seviyeye kadar swift dili anlatımı
                                 <ul>
                                    <li>Değişkenler-Sabitler-Optionals</li>
                                    <li>Karar Yapıları</li>
                                    <li>Listeler</li>
                                    <li>Dictionary</li>
                                    <li>Döngüler</li>
                                    <li>Fonksiyon ve Closure yapıları</li>
                                    <li>Map-Compact Map-Flat Map-Reduce</li>
                                    <li>Nesne Tabanlı Programlama</li>
                                       <ul>
                                          <li>Class</li>
                                          <li>Lazy loading</li>
                                          <li>Initializer</li>
                                          <li>Kalıtım-Override</li>
                                          <li>Properties</li>
                                          <li>Struct</li>
                                          <li>Erişim belirleyiciler</li>
                                          <li>Protokol</li>
                                          <li>Extension</li>
                                          <li>Enum</li>
                                          <li>Hata yönetimi</li>
                                          <li>Generic</li>
                                       </ul>
                                 </ul>
                              <li><i class="toggle-content"></i> <strong>Iphone Ipad Geliştirme :</strong> Iphone ve İpda için gerekli farklılıkların incelenmesi
                              <li><i class="toggle-content"></i> <strong>Arayüz tasarımları :</strong> Storyboard autolayout yapısı kullanılarak arayüz tasarımının yapılması
                              <li><i class="toggle-content"></i> <strong>MVC Mimarisi :</strong> MVC mimarisinin çalışma mantığının incelenmesi
                              <li><i class="toggle-content"></i> <strong>View Controller :</strong> View Controller yapısı ve çalışma mantığı
                              <li><i class="toggle-content"></i> <strong>Kullanıcı Bilgilendirmeleri :</strong> Kullanıcılara bilgi pencerelerinin çıkarımlası
                              <li><i class="toggle-content"></i> <strong>Gelişmiş tasarım elemanları :</strong> Özel asarım elemanları oluşturma
                              <li><i class="toggle-content"></i> <strong>Olay Yönetimi :</strong> Kullanıcı ile etkileşimlerde bulunma
                              <li><i class="toggle-content"></i> <strong>Liste Yapılarıyla Çalışmak :</strong> UITableView, UIollectionView yapılarının kullanımı
                              <li><i class="toggle-content"></i> <strong>Çok ekran ile çalışmak :</strong>
                                 <ul>
                                    <li>Ekranlar arası segue ile geçiş</li>
                                    <li>Ekranlar arası identifier ile geçiş</li>
                                    <li>Ekranlar arası veri taşıma</li>
                                 </ul>
                              <li><i class="toggle-content"></i> <strong>Launch screen :</strong> Açılış ekranı kullanımı ve açılışta işlem yapmak

                              <li><i class="toggle-content"></i> <strong>Sol menü :</strong> Sol menü yapılarının nasıl oluşturulabileceğinin incelenmesi
                              <li><i class="toggle-content"></i> <strong>Local veri saklama yöntemleri :</strong>
                                 <ul>
                                    <li>UserDefaults</li>
                                    <li>CoreData</li>
                                 </ul>
                              <li><i class="toggle-content"></i> <strong>CocoaPods ile ek kütüphaneler kullanımı :</strong>
                                 <ul>
                                    <li>Workspace oluşturma</li>
                                    <li>Cocoapods kullanarak kütüphaneler ekleme ve kullanma</li>
                                 </ul>
                              <li><i class="toggle-content"></i> <strong>Web servisleri ile çalışmak :</strong>
                                 <ul>
                                    <li>Json web servisleri ile JsonObject ve JsonArray kullanımları</li>
                                    <li>Codable yapısı</li>
                                 </ul>
                              <li><i class="toggle-content"></i> <strong>Kamera İşlemleri :</strong> Kameradan çekilen fotoğrafın kullanılması
                              <li><i class="toggle-content"></i> <strong>Galeri kullanımı :</strong> Galeriden fotoğraf seçimi ve kullanımı
                              <li><i class="toggle-content"></i> <strong>Konum kullanımı :</strong> Konum servislerine erişmek ve konum değerlerini işlemek
                              <li><i class="toggle-content"></i> <strong>Sensör kullanımları :</strong> Cihaz üzerindeki sensörlerin kullanımı
                              <li><i class="toggle-content"></i> <strong>MapKit :</strong> Mapkit ile harita eklemek ve konum kullanımı
                              <li><i class="toggle-content"></i> <strong>Uygulamalar arası veri aktarımı :</strong> Paylaşım yapılarını kullanmak

                              <li><i class="toggle-content"></i> <strong>Bildirim göstermek :</strong> Local bildirimlerin gösterilmesi
                           </ul>
                        </div>
                     </div>

                     <input class="btn btn-primary mb-xl" type="button" (click)="changeService(24)" data-toggle="modal" data-target="#exampleModal"   [value]="checkServicePrice(24)">

                     </div>
                  </section>
                  <section class="toggle" style="font-size: 14pt !important;">
                     <label>Size Özel İçerikler</label>
                     <div class="toggle-content" style="font-size: 13pt !important;">

                        <p class="lead">
                           <strong>Android</strong> ya da <strong>Ios</strong> platformlarındaki ihtiyaçlarınızı belirleyerek <strong>size özel içerikler</strong> ile yardımcı oluyoruz. Öncelikle ihtiyaçlarınızı detaylıca öğrendikten sonra size özel bir içerik hazırlıyor ve size sunuyoruz. Akabinde planlama ile bu içeriği gerek <strong>proje başı</strong>, gerekse <strong>eğitim</strong> şeklinde sizlere aktarıyoruz.
                        </p>

                        <p class="lead">
                           <strong>Uzaktan ya da yerinde hizmet verilmektedir.</strong> Ücretlendirme <strong>saatlik</strong> olarak yapılır.
                           <br>

                           Öngördüğünüz süreye göre satınalma yapabilirsiniz. Sürenin daha fazla sürmesi halinde iş sonucunda ek satınalma gerekmektedir.
                        </p>


                        <input class="btn btn-primary mb-xl" type="button" (click)="changeService(25)" data-toggle="modal" data-target="#exampleModal"   [value]="checkServicePrice(25)">

                     </div>
                  </section>
        </div>
      </div>
    </div>

  </div>

</div>

<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg" style="width: 96%;" role="document" >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{selectedService.price>0? selectedService?.name +" Satın Al":selectedService.name+" Görüşme Talebi"}}   </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

					<div class="row" *ngIf="IsFree">
						<div class="col-md-12">

							<h2 class="mb-sm mt-sm"><strong>Sizinle</strong> iletişime geçelim</h2>
								<div class="row">
									<div class="form-group">
										<div class="col-md-6">
											<label>Ad Soyad *</label>
											<input type="text" [(ngModel)]="contact.name" data-msg-required="Lütfen adınızı giriniz." maxlength="100" class="form-control" name="name" id="name" required>
										</div>
										<div class="col-md-6">
											<label>E-Posta *</label>
											<input type="email" [(ngModel)]="contact.email"  data-msg-required="Lütfen E-Posta adresinizi giriniz." data-msg-email="Lütfen geçerli bir E-Posta adresi giriniz." maxlength="100" class="form-control" name="email" id="email" required>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="form-group">
										<div class="col-md-12">
											<label>Telefon</label>
											<input type="number" [(ngModel)]="contact.phone" onkeydown="return (event.keyCode !== 69 && $(this).val().length<13)"  maxlength="15" class="form-control" name="phone" id="phone">
										</div>
									</div>
								</div>
								<div class="row">
									<div class="form-group">
										<div class="col-md-12">
											<label>Konu</label>
											<input type="text" [(ngModel)]="contact.subject"  data-msg-required="Lütfen konu giriniz." maxlength="100" class="form-control" name="subject" id="subject" required>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="form-group">
										<div class="col-md-12">
											<label>Mesaj *</label>
											<textarea maxlength="5000" [(ngModel)]="contact.message"  data-msg-required="Lütfen mesajınızı giriniz." rows="10" class="form-control" name="message" id="message" required></textarea>
										</div>
									</div>
								</div>
						</div>
          </div>

          <div *ngIf="!IsFree">
            <div class="row">
              <div class="col-md-12">
                <h2 class="mb-sm mt-sm"><strong>Detayları belirtip</strong> satın almayı yapınız</h2>
                  <div class="row">
                    <div class="form-group">
                      <div class="col-md-12">
                        <label for="productName" class="col-md-2 col-xs-12"><strong>Talep Edilen Ürün :</strong></label>
                        <input disabled="true" style="width:40%;"  class="col-md-3 col-xs-12"  value="{{serviceRegistration.serviceName}}"  name="productName" id="productName">
                      </div>
                    </div>
                  </div>


                  <div class="row" *ngIf="selectedService?.educationDate.length>0" style="padding-left: 15px;">
                    <div class="form-group">
                        <label for="sorting-dropdown2"  class="col-md-2 col-xs-12"><strong>Detay :</strong></label>

                            <select style="padding-left: 3px;" class="col-md-9 col-xs-12" [(ngModel)]="serviceRegistration.calendarId"  (ngModelChange)="ChangeDate($event)" id="sorting-dropdown2">
                              <option *ngFor="let item of selectedService.educationDate" [value]="item.id" title="{{item.date}}" data-sorting="True">{{item.date}}</option>
                            </select>
                    </div>
                  </div>

                  <div class="row" style="padding-left: 15px;">
                    <div class="form-group">
                          <label for="unitPrice"  class="col-md-2 col-xs-12"><strong>Birim fiyat : </strong></label>
                          <input disabled="true" style="padding-left: 3px;"  class="col-md-2 col-xs-12" value="{{serviceRegistration.price*serviceRegistration.quantity |  currency: 'TRY':'':''}} TL"  name="unitPrice" id="unitPrice">
                    </div>
                  </div>
                  <div class="row" style="padding-left: 15px;">

                    <div class="form-group">
                        <label for="sorting-dropdown"  class="col-md-2 col-xs-12"><strong>Miktar : </strong></label>
                        <select  class="col-md-1 col-xs-12" [(ngModel)]="serviceRegistration.quantity"  (ngModelChange)="ChangeQuantity($event)" id="sorting-dropdown">
                          <option [value]="1" data-sorting="True">1</option>
                          <option [value]="2" data-sorting="True">2</option>
                          <option [value]="3" data-sorting="True">3</option>
                          <option [value]="4" data-sorting="True">4</option>
                          <option [value]="5" data-sorting="True">5</option>
                          <option [value]="10" data-sorting="True">10</option>
                        </select>
                    </div>
                  </div>

                <div class="panel panel-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-right: 30px;">
                  <div class="panel-heading">
                    <h4 class="panel-title"><i class="fa fa-user"></i>  İletişim Bilgisi </h4>
                  </div>
                    <div class="panel-body">
                      <fieldset id="account">
                      <div class="row">
                        <div class="form-group ">
                          <div class="form-group required paddinginput col-md-4 col-lg-4 col-sm-12 col-xs-12">
                            <label for="input-payment-firstname" class="control-label">Adınız ve Soyadınız *</label>
                            <input type="text" class="form-control" [(ngModel)]="serviceRegistration.name" id="input-payment-firstname"  placeholder="Adınız ve Soyadınız " name="firstname">
                          </div>
                          <div class="form-group required paddinginput col-md-4 col-lg-4 col-sm-12 col-xs-12">
                            <label>E-Posta *</label>
                            <input type="email" [(ngModel)]="serviceRegistration.email" value="" data-msg-required="Lütfen E-Posta adresinizi giriniz." placeholder="E-Posta Adresi" data-msg-email="Lütfen geçerli bir E-Posta adresi giriniz." maxlength="100" class="form-control" name="email" id="email" required>
                          </div>
                        <div class="form-group required paddinginput col-md-4 col-lg-4 col-sm-12 col-xs-12">
                          <label for="input-payment-telephone" class="control-label">Telefon Numarası *</label>
                          <input type="number" class="form-control" [(ngModel)]="serviceRegistration.phone" onkeydown="return (event.keyCode !== 69 && $(this).val().length<13)" id="input-payment-telephone" placeholder="Telefon Numarası"  name="Vergi">
                        </div>
                      </div>
                    </div>

                        <div class="row">
                          <div class="form-group">
                            <div class="col-md-12">
                              <label>Detaylar (Belirtmek istediğiniz detayları buraya yazabilirsiniz)</label>
                              <textarea maxlength="5000" [(ngModel)]="serviceRegistration.message" data-msg-required="Lütfen mesajınızı giriniz." rows="5" class="form-control" name="message" id="detail"></textarea>
                            </div>
                          </div>
                        </div>
                      </fieldset></div></div>
                  <div class="panel panel-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-right: 30px;">
                    <div class="panel-heading">
                      <h4 class="panel-title"><i class="fa fa-user"></i>  Fatura Bilgisi </h4>
                    </div>
                      <div class="panel-body">

                        <div class="row" style="text-align: center;padding-bottom: 3%;">
                          <button type="button" (click)="CompanyChange(true)" class="btn btn-primary"  [ngClass]="{'btnclr': serviceRegistration.isCompany}" ><span class="fa fa-building" style="padding-right:10px"></span> Kurumsal</button>
                          <button type="button" (click)="CompanyChange(false)" class="btn btn-primary" style="margin-left: 5%" [ngClass]="{'btnclr': !serviceRegistration.isCompany}"  ><span class="fa fa-user" style="padding-right:10px"></span> Bireysel</button>
                      </div>
                        <fieldset id="account">

                          <div class="row">
                                <div class="form-group required paddinginput col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                  <label for="input-payment-firstname" class="control-label">{{serviceRegistration.isCompany?"Firma Adı *":"Adınız ve Soyadınız *"}}</label>
                                  <input type="text" class="form-control" [(ngModel)]="serviceRegistration.taxName" id="input-payment-firstname"  placeholder="{{serviceRegistration.isCompany?'Firma Adı':'Adınız ve Soyadınız'}}" name="firstname">
                              </div>


                          </div>
                            <div *ngIf="serviceRegistration.isCompany" class="form-group required paddinginput col-md-12 col-lg-12 col-sm-12 col-xs-12" style="    padding: 0px;">
                              <label for="input-payment-telephone" class="control-label">Vergi Dairesi *</label>
                              <div class="ng-autocomplete">
                                <ng-autocomplete
                                  [(ngModel)]="taxCompany"
                                  [data]="taxOffices"
                                  [placeHolder]="'Vergi Dairesi Seçin'"
                                  [searchKeyword]="'name'"
                                  (inputChanged)='onChangeSearch($event)'
                                  [itemTemplate]="itemTemplate"
                                  [notFoundTemplate]="notFoundTemplate">
                                </ng-autocomplete>

                                <ng-template #itemTemplate let-item>
                                <a [innerHTML]="item.name"></a>
                                </ng-template>

                                <ng-template #notFoundTemplate let-notFound>
                                <div [innerHTML]="notFound"></div>
                                </ng-template>
                                </div>
                            </div>
                            <div class="form-group required paddinginput col-md-12 col-lg-12 col-sm-12 col-xs-12" style="    padding: 0px;">
                              <label for="input-payment-telephone" class="control-label">{{serviceRegistration.isCompany?"Vergi Numarası *":"TC Numarası *"}}</label>
                              <input type="number"   class="form-control" onkeydown="return (event.keyCode !== 69 && $(this).val().length<12)"   [(ngModel)]="serviceRegistration.taxNumberOrTC" id="input-payment-telephone" placeholder="{{serviceRegistration.isCompany?'Vergi Numarası *':'TC Numarası *'}}"  name="Vergi">
                            </div>
                            <div class="row">
                              <div  class="form-group required  col-md-6 col-xl-6 col-sm-12 col-xs-12">
                                <label for="input-payment-telephone" class="control-label">İl *</label>
                                <select  [ngModel]="serviceRegistration.cityId" name="make" (ngModelChange)="ChangeCity($event)"  id="so_make0" class="form-control">
                                  <option [value]="0" selected="">Şehir Seçin</option>
                                  <option [value]="i.id" *ngFor="let i of city">{{i.name}}</option>
                                </select>
                              </div>
                              <div class="form-group required  col-md-6 col-xl-6 col-sm-12 col-xs-12">
                                <label for="input-payment-telephone" class="control-label">İlçe *</label>
                                <select [disabled]="serviceRegistration.cityId==0"  [ngModel]="serviceRegistration.townId" name="make" (ngModelChange)="ChangeCounty($event)"  id="so_make0" class="form-control">
                                  <option [value]="i.id" *ngFor="let i of town">{{i.name}}</option>
                                </select>
                              </div>
                            </div>
                          <div class="form-group required paddinginput col-md-12 col-lg-12 col-sm-12 col-xs-12" style="    padding: 0px;">
                            <label for="input-payment-telephone" class="control-label">Adres *</label>
                             <textarea rows="2" class="form-control" [(ngModel)]="serviceRegistration.address" id="confirm_comment" name="Adres"></textarea>
                          </div>

                        </fieldset>
                        </div>
                    </div>
                  <br/>
                  <div class="checkbox-custom checkbox-default col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <input [(ngModel)]="Agreement" type="checkbox" id="acceptcontract" value="1">
                    <label style="padding-left: 5px;" for="acceptcontract"><a target="_blank" href="/distance-selling-contract">Mesafeli Satış Sözleşmesi</a>ni okudum onaylıyorum.</label>
                  </div>
                  <br/>
              </div>
            </div>
          </div>

      </div>
      <div class="row" style="padding-left: 5%;" *ngIf="selectedService?.note?.length>0">
        <p class="badge badge-success">  Not: {{selectedService?.note}}</p>
       </div>
      <div class="modal-footer">
        <input *ngIf="IsFree" type="button" value="Gönder" (click)="sendContact()" class="btn btn-primary btn-lg mb-xlg" id="send" data-loading-text="Gönderiliyor...">
        <input *ngIf="!IsFree"  [disabled]="!buyButtonActive" type="button" [value]="buttonText"  (click)="sendRegisteration()" class="btn btn-primary btn-lg mb-xlg" id="send" data-loading-text="Gönderiliyor...">
        <button type="button" class="btn btn-secondary btn-lg mb-xlg" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
